import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isString, endsWith } from 'lodash';

import { CrudBaseService } from '../crud.service';
import { TradingAccount, TradingAccountPlan } from '../models';
import { FilterObjectBuilder, FilterOperator } from '../param-builders';

@Injectable()
export class TradingAccountService extends CrudBaseService<TradingAccount> {
    constructor(httpClient: HttpClient) {
        super('/tradingaccount', httpClient);
    }

    filterByUser(userId: string): Observable<TradingAccount[]> {
        const filterBuilder = new FilterObjectBuilder();
        filterBuilder.by('users_linked[].id', FilterOperator.eq, userId);
        return this.filter(filterBuilder.apiFilter());
    }

    filterByUserAndTradingAccount(userId: string, tradingaccountName: string): Observable<TradingAccount[]> {
        const filterBuilder = new FilterObjectBuilder();
        filterBuilder
            .by('users_linked[].id', FilterOperator.eq, userId)
            .by('name', FilterOperator.like, tradingaccountName);
        return this.filter(filterBuilder.apiFilter());
    }

    filterByTAId(tradingAccountId: string): Observable<TradingAccount[]> {
        const filterBuilder = new FilterObjectBuilder();
        filterBuilder.by('enable', FilterOperator.eq, 'true').by('id', FilterOperator.like, tradingAccountId);
        return this.filter(filterBuilder.apiFilter());
    }

    isDemoOrLive(tradingAccount: TradingAccount | string): TradingAccountPlan {
        let platformString = '';
        if (isString(tradingAccount)) {
            platformString = tradingAccount;
        } else {
            platformString = tradingAccount.platform_lookup;
        }

        if (endsWith(platformString, '-D')) {
            return TradingAccountPlan.DEMO;
        } else if (endsWith(platformString, '-L')) {
            return TradingAccountPlan.LIVE;
        } else {
            return TradingAccountPlan.UnKnown;
        }
    }
}
